import { isOfferItemType } from './isOfferItemType';
export const getSelectItemInitialValues = (item, selectedItems) => {
    let checked = false;
    let quantity = '1';
    if (!isOfferItemType(item)) {
        const selectedItem = selectedItems.find((selectedItem) => selectedItem.variantId === item.variantId);
        if (selectedItem) {
            checked = true;
            quantity = selectedItem.quantity;
        }
    }
    return {
        checked,
        quantity,
    };
};
